import { makeLayout, render } from "lib/controller";
import { navigation } from "./controller";
import { chatPageController } from "./controller";

export default (router) => {
  router(`/chat`, navigation, chatPageController, makeLayout, render);
  router(`/chat/:chatId`, navigation, chatPageController, makeLayout, render);
};
